import { render, staticRenderFns } from "./ModalCategory.vue?vue&type=template&id=fa65ffa8&"
import script from "./ModalCategory.vue?vue&type=script&lang=js&"
export * from "./ModalCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports